module.exports = __webpack_public_path__ + "82f08754f38d32180f2ce7780455c3df.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/G2400.jpg
// module id = 688
// module chunks = 0